<i18n>
  {
    "en": {
      "dinerMargin": "Margin by diner"
    },
    "es": {
      "dinerMargin": "Margen por comensal"
    }
  }
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import KpiComponent from './KpiComponent.vue';
import * as KPITypes from '../constants';

@Component
@MapActions(['calculateDinerMarginKPI'])
export default class DinerMarginKpi extends KpiComponent {
  icon = 'mdi-account-cash'

  kpiType = KPITypes.DINER_MARGIN;

  isCurrencyUnit = true

  get title() {
    return this.$t('dinerMargin');
  }

  async calculate() {
    await this.calculateDinerMarginKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
